import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const pillarsData = [
  {
    id: 1,
    title: '影響力基地',
    subtitle: 'Impact Base',
    icon: 'Home',
    desc: '以松山機場旁60年歷史老眷村改建的「相信世代 University Cafe」為起點。發起「社群公益咖啡」、「影響力夥伴進駐」，創造社區再生新可能。',
    image: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=600&h=400&fit=crop&q=80'
  },
  {
    id: 2,
    title: '影響力學習',
    subtitle: 'Impact Learning',
    icon: 'Globe',
    desc: '分享世界各地的社會創新案例，透過「海外見學」、「Impact Cafe Exchange」等計畫，串聯志同道合的夥伴一同實踐改變藍圖。',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&h=400&fit=crop&q=80'
  },
  {
    id: 3,
    title: '影響力陪伴',
    subtitle: 'Impact Mentorship',
    icon: 'Users',
    desc: '跨世代經驗傳承。與資深人資導師合作「職涯會客室」、「非暴力溝通」等課程，陪伴青年開啟有意義的職涯旅程。',
    image: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?w=600&h=400&fit=crop&q=80'
  },
  {
    id: 4,
    title: '影響力行動',
    subtitle: 'Impact Action',
    icon: 'Zap',
    desc: '透過「青年影響力公寓」、「社區共學」等計畫，幫助年輕朋友發揮所長、串接資源，成為實踐永續價值的原動力。',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=400&fit=crop&q=80'
  }
];

const PillarCard = ({ data, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay: index * 0.1 }}
    className="group bg-white rounded-2xl overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-all duration-300 border border-gray-100"
  >
    <div className="h-48 overflow-hidden relative">
      <div className="absolute inset-0 bg-teal-900/20 group-hover:bg-transparent transition-colors duration-500 z-10" />
      <img 
        src={data.image} 
        alt={data.title} 
        className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
      />
      <div className="absolute top-4 right-4 z-20 w-10 h-10 bg-white/90 backdrop-blur rounded-full flex items-center justify-center text-teal-600 shadow-sm">
        <SafeIcon name={data.icon} />
      </div>
    </div>
    <div className="p-8">
      <div className="text-teal-600 font-bold text-xs uppercase tracking-wider mb-2">{data.subtitle}</div>
      <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-teal-600 transition-colors">{data.title}</h3>
      <p className="text-gray-600 leading-relaxed mb-6 h-24 overflow-hidden text-ellipsis">
        {data.desc}
      </p>
      <button className="text-teal-600 font-medium inline-flex items-center gap-2 hover:gap-3 transition-all group/btn">
        瞭解更多 <SafeIcon name="ArrowRight" className="w-4 h-4" />
      </button>
    </div>
  </motion.div>
);

const Pillars = () => {
  return (
    <section className="py-24 bg-neutral-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-teal-600 font-bold tracking-widest uppercase mb-4 text-sm">Upcoming Events & Initiatives</h2>
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            打造跨世代、跨國界的<br className="visible md:hidden"/>社會共好平台
          </h3>
          <p className="text-gray-600 text-lg">
            成為永續創新人才實現創新夢想道路上的後盾，透過世代共好的方式，協助啟動善的循環，共建更美好的社會。
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {pillarsData.map((pillar, index) => (
            <PillarCard key={pillar.id} data={pillar} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pillars;